import { useEmailWidgetHandlers } from '../../../../../../common/helpers/widget-helpers/use-email-widget-handlers';

export const useMasterOrEntityEmailFormHandlers = ({
  widget,
  currentEntity,
  isMaster,
  masterStateAndHandlers,
}) => {
  const {
    subjectValue: masterSubjectValue,
    setSubjectValue: setMasterSubjectValue,
    previewTextValue: masterPreviewTextValue,
    bodyValue: masterBodyValue,
    setBodyValue: setMasterBodyValue,
    onChangeSubject: onChangeMasterSubject,
    onChangePreviewText: onChangeMasterPreviewText,
    setEmailSubjectRef: setMasterEmailSubjectRef,
    setEmailPreviewTextRef: setMasterEmailPreviewTextRef,
    updateInsertEmojiSubject: updateMasterInsertEmojiSubject,
    updateInsertEmojiPreviewText: updateMasterInsertEmojiPreviewText,
    updateInsertAttributeSubject: updateMasterInsertAttributeSubject,
    updateInsertAttributePreviewText: updateMasterInsertAttributePreviewText,
    ccInputValue: masterCcInputValue,
    setCcInputValue: setMasterCcInputValue,
    setBccInputValue: setMasterBccInputValue,
    bccInputValue: masterBccInputValue,
    ccEmails: masterCcEmails,
    setCCEmails: setMasterCcEmails,
    bccEmails: masterBccEmails,
    setBCCEmails: setMasterBccEmails,
    attachments: masterAttachments,
    setAttachments: setMasterAttachments,
  } = masterStateAndHandlers;

  const {
    subjectValue: entitySubjectValue,
    setSubjectValue: setEntitySubjectValue,
    setBodyValue: setEntityBodyValue,
    onChangeSubject: onChangeEntitySubject,
    onChangePreviewText: onChangeEntityPreviewText,
    setEmailSubjectRef: setEntityEmailSubjectRef,
    setEmailPreviewTextRef: setEntityEmailPreviewTextRef,
    updateInsertEmojiSubject: updateEntityInsertEmojiSubject,
    updateInsertEmojiPreviewText: updateEntityInsertEmojiPreviewText,
    updateInsertAttributeSubject: updateEntityInsertAttributeSubject,
    updateInsertAttributePreviewText: updateEntityInsertAttributePreviewText,
    previewTextValue: entityPreviewTextValue,
    bodyValue: entityBodyValue,
    ccInputValue: entityCcInputValue,
    setCcInputValue: setEntityCcInputValue,
    setBccInputValue: setEntityBccInputValue,
    bccInputValue: entityBccInputValue,
    ccEmails: entityCcEmails,
    setCCEmails: setEntityCcEmails,
    bccEmails: entityBccEmails,
    setBCCEmails: setEntityBccEmails,
    attachments: entityAttachments,
    setAttachments: setEntityAttachments,
  } = useEmailWidgetHandlers({ widget }, true, currentEntity);

  const getProp = (masterProp, entityProps) =>
    isMaster ? masterProp : entityProps;

  const setBodyValue = getProp(setMasterBodyValue, setEntityBodyValue);
  const setSubjectValue = getProp(setMasterSubjectValue, setEntitySubjectValue);
  const onChangeSubject = getProp(onChangeMasterSubject, onChangeEntitySubject);
  const onChangePreviewText = getProp(
    onChangeMasterPreviewText,
    onChangeEntityPreviewText,
  );
  const setEmailSubjectRef = getProp(
    setMasterEmailSubjectRef,
    setEntityEmailSubjectRef,
  );
  const setEmailPreviewTextRef = getProp(
    setMasterEmailPreviewTextRef,
    setEntityEmailPreviewTextRef,
  );
  const updateInsertEmojiSubject = getProp(
    updateMasterInsertEmojiSubject,
    updateEntityInsertEmojiSubject,
  );
  const updateInsertEmojiPreviewText = getProp(
    updateMasterInsertEmojiPreviewText,
    updateEntityInsertEmojiPreviewText,
  );
  const updateInsertAttributeSubject = getProp(
    updateMasterInsertAttributeSubject,
    updateEntityInsertAttributeSubject,
  );
  const updateInsertAttributePreviewText = getProp(
    updateMasterInsertAttributePreviewText,
    updateEntityInsertAttributePreviewText,
  );
  const previewTextValue = getProp(
    masterPreviewTextValue,
    entityPreviewTextValue,
  );
  const subjectValue = getProp(masterSubjectValue, entitySubjectValue);
  const bodyValue = getProp(masterBodyValue, entityBodyValue);
  const ccEmails = getProp(masterCcEmails, entityCcEmails);
  const setCCEmails = getProp(setMasterCcEmails, setEntityCcEmails);
  const bccEmails = getProp(masterBccEmails, entityBccEmails);
  const setBCCEmails = getProp(setMasterBccEmails, setEntityBccEmails);
  const attachments = getProp(masterAttachments, entityAttachments);
  const setAttachments = getProp(setMasterAttachments, setEntityAttachments);
  const ccInputValue = getProp(masterCcInputValue, entityCcInputValue);
  const setCcInputValue = getProp(setMasterCcInputValue, setEntityCcInputValue);
  const bccInputValue = getProp(masterBccInputValue, entityBccInputValue);
  const setBccInputValue = getProp(
    setMasterBccInputValue,
    setEntityBccInputValue,
  );

  return {
    subjectValue,
    previewTextValue,
    bodyValue,
    setBodyValue,
    setSubjectValue,
    onChangeSubject,
    onChangePreviewText,
    setEmailSubjectRef,
    setEmailPreviewTextRef,
    updateInsertEmojiSubject,
    updateInsertEmojiPreviewText,
    updateInsertAttributeSubject,
    updateInsertAttributePreviewText,
    ccInputValue,
    setCcInputValue,
    setBccInputValue,
    bccInputValue,
    ccEmails,
    setCCEmails,
    bccEmails,
    setBCCEmails,
    attachments,
    setAttachments,
  };
};
